import { Component } from "@angular/core";

@Component({
  selector: "rd-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"]
})
export class LoadingComponent {
  constructor() {}
}
